import React from 'react';
import { TimelineHistogram } from '@bryntum/scheduler';
import { createWidget, shouldComponentUpdate, processWidgetContent } from './WrapperHelper.js';
export class BryntumTimelineHistogram extends React.Component {
    constructor() {
        super(...arguments);
        this.processWidgetContent = processWidgetContent;
        this.portalContainerClass = 'b-react-portal-container';
        this.state = {
            portals: new Map(),
            generation: 0
        };
        this.projectStores = false;
        this.dataStores = {};
    }
    componentDidMount() {
        this.instance = createWidget(this);
    }
    componentWillUnmount() {
        var _a, _b;
        (_b = (_a = this.instance) === null || _a === void 0 ? void 0 : _a.destroy) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdate(this, nextProps, nextState);
    }
    render() {
        const className = `b-react-timeline-histogram-container`;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: className, ref: (element) => (this.element = element) }, Array.from(this.state.portals).map((item) => item[1])),
            React.createElement("div", { ref: el => (this.portalsCache = el), className: "b-react-portals-cache", style: { display: 'none' } })));
    }
}
BryntumTimelineHistogram.instanceClass = TimelineHistogram;
BryntumTimelineHistogram.instanceName = 'TimelineHistogram';
BryntumTimelineHistogram.isView = true;
BryntumTimelineHistogram.featureNames = [
    'cellCopyPasteFeature',
    'cellEditFeature',
    'cellMenuFeature',
    'cellTooltipFeature',
    'columnAutoWidthFeature',
    'columnDragToolbarFeature',
    'columnLinesFeature',
    'columnPickerFeature',
    'columnRenameFeature',
    'columnReorderFeature',
    'columnResizeFeature',
    'excelExporterFeature',
    'fileDropFeature',
    'fillHandleFeature',
    'filterFeature',
    'filterBarFeature',
    'groupFeature',
    'groupSummaryFeature',
    'headerMenuFeature',
    'headerZoomFeature',
    'mergeCellsFeature',
    'nonWorkingTimeFeature',
    'panFeature',
    'pdfExportFeature',
    'printFeature',
    'quickFindFeature',
    'regionResizeFeature',
    'resourceMenuFeature',
    'resourceTimeRangesFeature',
    'rowCopyPasteFeature',
    'rowExpanderFeature',
    'rowReorderFeature',
    'rowResizeFeature',
    'scheduleTooltipFeature',
    'searchFeature',
    'sortFeature',
    'splitFeature',
    'stickyCellsFeature',
    'stripeFeature',
    'summaryFeature',
    'timeAxisHeaderMenuFeature',
    'timeRangesFeature',
    'treeFeature',
    'treeGroupFeature'
];
BryntumTimelineHistogram.configNames = [
    'adopt',
    'aggregateDataEntry',
    'aggregateHistogramDataForGroups',
    'allowOver',
    'anchorToTarget',
    'animateRemovingRows',
    'animateTreeNodeToggle',
    'ariaDescription',
    'ariaLabel',
    'autoAdjustTimeAxis',
    'autoClose',
    'autoHeight',
    'autoHide',
    'autoShow',
    'barTooltipTemplate',
    'bbar',
    'bodyCls',
    'bubbleEvents',
    'bufferCoef',
    'bufferThreshold',
    'callOnFunctions',
    'closable',
    'closeAction',
    'collapsed',
    'collapsible',
    'config',
    'contentElementCls',
    'contextMenuTriggerEvent',
    'dataModelField',
    'defaultRegion',
    'destroyStore',
    'disableGridColumnIdWarning',
    'disableGridRowModelWarning',
    'dismissDelay',
    'dock',
    'durationDisplayPrecision',
    'enableRecurringEvents',
    'enableSticky',
    'enableTextSelection',
    'features',
    'fillLastColumn',
    'fixedRowHeight',
    'focusOnToFront',
    'footer',
    'forElement',
    'forSelector',
    'fullRowRefresh',
    'getBarText',
    'getBarTip',
    'getDataEntryForAggregating',
    'getHtml',
    'getOutlineClass',
    'getRecordData',
    'getRectClass',
    'getRowHeight',
    'hardRefreshOnTimeAxisReconfigure',
    'header',
    'hideDelay',
    'hideHorizontalScrollbar',
    'hideOnDelegateChange',
    'histogramWidgetClass',
    'ignoreDomEventsWhileScrolling',
    'ignoreParentReadOnly',
    'infiniteScroll',
    'initAggregatedDataEntry',
    'keyMap',
    'listeners',
    'loadingMsg',
    'loadMask',
    'loadMaskDefaults',
    'loadMaskError',
    'localizable',
    'managedEventSizing',
    'maskDefaults',
    'masked',
    'maximizable',
    'maxTimeAxisUnit',
    'modal',
    'monitorResize',
    'mouseOffsetX',
    'mouseOffsetY',
    'owner',
    'partner',
    'plugins',
    'preserveFocusOnDatasetChange',
    'preserveScrollOnDatasetChange',
    'preventTooltipOnTouch',
    'relayStoreEvents',
    'resizeToFitIncludesHeader',
    'resourceTimeRangeRenderer',
    'responsiveLevels',
    'ripple',
    'rootElement',
    'scaleColumn',
    'scrollerClass',
    'scrollManager',
    'series',
    'showDirty',
    'showOnClick',
    'showOnHover',
    'snapRelativeToEventStartDate',
    'stateful',
    'statefulEvents',
    'stateId',
    'stateProvider',
    'stickyHeaders',
    'strips',
    'subGridConfigs',
    'suppressFit',
    'syncMask',
    'tab',
    'tbar',
    'timeAxis',
    'trackMouse',
    'ui',
    'visibleZoomFactor',
    'weekStartDay',
    'weight',
    'zoomKeepsOriginalTimespan',
    'zoomOnMouseWheel',
    'zoomOnTimeAxisDoubleClick'
];
BryntumTimelineHistogram.propertyConfigNames = [
    'alignSelf',
    'appendTo',
    'ariaLive',
    'barMargin',
    'cls',
    'columnLines',
    'columns',
    'data',
    'dataset',
    'disabled',
    'displayDateFormat',
    'emptyText',
    'enableEventAnimations',
    'enableUndoRedoKeys',
    'endDate',
    'eventColor',
    'eventStyle',
    'extraData',
    'fillTicks',
    'flex',
    'forceFit',
    'height',
    'hidden',
    'hideFooters',
    'hideHeaders',
    'hideRowHover',
    'histogramWidget',
    'hoverDelay',
    'id',
    'insertBefore',
    'insertFirst',
    'longPressTime',
    'margin',
    'maxHeight',
    'maximized',
    'maxWidth',
    'maxZoomLevel',
    'minHeight',
    'minWidth',
    'minZoomLevel',
    'onBeforeAssignmentDelete',
    'onBeforeCancelCellEdit',
    'onBeforeCellDelete',
    'onBeforeCellEditStart',
    'onBeforeClose',
    'onBeforeColumnDragStart',
    'onBeforeColumnDropFinalize',
    'onBeforeColumnResize',
    'onBeforeCopy',
    'onBeforeDestroy',
    'onBeforeEventDelete',
    'onBeforeFillHandleDragStart',
    'onBeforeFinishCellEdit',
    'onBeforeHide',
    'onBeforeHistogramDataCacheSet',
    'onBeforePan',
    'onBeforePaste',
    'onBeforePdfExport',
    'onBeforePresetChange',
    'onBeforeRenderHistogramRow',
    'onBeforeRenderRecordHistogram',
    'onBeforeRenderRow',
    'onBeforeRenderRows',
    'onBeforeSelectionChange',
    'onBeforeSetRecord',
    'onBeforeShow',
    'onBeforeToggleGroup',
    'onBeforeToggleNode',
    'onCancelCellEdit',
    'onCatchAll',
    'onCellClick',
    'onCellContextMenu',
    'onCellDblClick',
    'onCellMenuBeforeShow',
    'onCellMenuItem',
    'onCellMenuShow',
    'onCellMenuToggleItem',
    'onCellMouseEnter',
    'onCellMouseLeave',
    'onCellMouseOut',
    'onCellMouseOver',
    'onCollapse',
    'onCollapseNode',
    'onColumnDrag',
    'onColumnDragStart',
    'onColumnDrop',
    'onColumnResize',
    'onColumnResizeStart',
    'onContextMenuItem',
    'onContextMenuToggleItem',
    'onCopy',
    'onDataChange',
    'onDateRangeChange',
    'onDestroy',
    'onDragSelecting',
    'onExpand',
    'onExpandNode',
    'onFileDrop',
    'onFillHandleBeforeDragFinalize',
    'onFillHandleDrag',
    'onFillHandleDragAbort',
    'onFillHandleDragEnd',
    'onFillHandleDragStart',
    'onFinishCellEdit',
    'onFocusIn',
    'onFocusOut',
    'onGridRowAbort',
    'onGridRowBeforeDragStart',
    'onGridRowBeforeDropFinalize',
    'onGridRowDrag',
    'onGridRowDragStart',
    'onGridRowDrop',
    'onHeaderClick',
    'onHeaderMenuBeforeShow',
    'onHeaderMenuItem',
    'onHeaderMenuShow',
    'onHeaderMenuToggleItem',
    'onHide',
    'onHistogramDataCacheSet',
    'onMouseOut',
    'onMouseOver',
    'onPaint',
    'onPaste',
    'onPdfExport',
    'onPointerOver',
    'onPresetChange',
    'onReadOnly',
    'onRecompose',
    'onRenderRow',
    'onRenderRows',
    'onResize',
    'onResourceMenuBeforeShow',
    'onResourceMenuItem',
    'onResourceMenuShow',
    'onResourceMenuToggleItem',
    'onResourceTimeRangeClick',
    'onResourceTimeRangeContextMenu',
    'onResourceTimeRangeDblClick',
    'onResourceTimeRangeMouseDown',
    'onResourceTimeRangeMouseOut',
    'onResourceTimeRangeMouseOver',
    'onResourceTimeRangeMouseUp',
    'onResponsive',
    'onRowMouseEnter',
    'onRowMouseLeave',
    'onScroll',
    'onSelectionChange',
    'onSelectionModeChange',
    'onShow',
    'onSplit',
    'onSplitterCollapseClick',
    'onSplitterDragEnd',
    'onSplitterDragStart',
    'onSplitterExpandClick',
    'onStartCellEdit',
    'onSubGridCollapse',
    'onSubGridExpand',
    'onTimeAxisChange',
    'onTimeAxisHeaderClick',
    'onTimeAxisHeaderContextMenu',
    'onTimeAxisHeaderDblClick',
    'onTimeAxisHeaderMenuBeforeShow',
    'onTimeAxisHeaderMenuItem',
    'onTimeAxisHeaderMenuShow',
    'onTimelineContextChange',
    'onTimelineViewportResize',
    'onTimeRangeHeaderClick',
    'onTimeRangeHeaderContextMenu',
    'onTimeRangeHeaderDblClick',
    'onToggleGroup',
    'onToggleNode',
    'onToolClick',
    'onUnsplit',
    'onVisibleDateRangeChange',
    'preserveScroll',
    'presets',
    'readOnly',
    'rowHeight',
    'rowLines',
    'scrollable',
    'selectionMode',
    'showBarTip',
    'snap',
    'startDate',
    'store',
    'tickSize',
    'timeZone',
    'title',
    'tools',
    'transitionDuration',
    'viewPreset',
    'visibleDate',
    'width',
    'workingTime'
];
BryntumTimelineHistogram.propertyNames = [
    'accessibility',
    'scrollLeft',
    'scrollTop',
    'scrollX',
    'selectedCell',
    'selectedCells',
    'selectedRecord',
    'selectedRecords',
    'selectedRows',
    'state',
    'timeResolution',
    'tooltip',
    'zoomLevel'
];
//# sourceMappingURL=BryntumTimelineHistogram.js.map